export default class InvalidResponse extends Error {

    constructor(data: any) {
        super(JSON.stringify(data));
    }
}